

import { ProductModel, ShiftTypeModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import {shiftTypesStore} from '@/libs/shift-types/+state/store';

@Component({})
export default class ShiftTypeSelect extends Vue {

    @VModel() innerValue!: string;
    @Prop({ default: "" }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: false }) truncateSelection!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): ShiftTypeModel[] {
        return [...(shiftTypesStore.useGetter(CrudGetter.Data) as ShiftTypeModel[])].sort((a: ShiftTypeModel, b: ShiftTypeModel) => {
            if(a.name! < b.name!) { return -1; }
            if(a.name! > b.name!) { return 1; }
            return 0;
        });
    }

    onChange(e: any) {
        const shiftType = (shiftTypesStore.useGetter(CrudGetter.Data) ?? []) as ShiftTypeModel[];
        this.$emit('input', e);
        this.$nextTick(() => {
            this.$emit('change', e);
            this.$emit('select', shiftType.filter((x) => x.id == e).shift() ?? null);
        });
    }
}
